import { useState } from "react";
import { BASE_API } from '../api/Globals';
import { helpHttp } from "../helpers/helpHttp";
import { storage } from "../helpers/storage";

export const useFormReAssignment = (initialForm, validateForm, handleHidden, solicitudid) => {
	const [form, setForm] = useState(initialForm);
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);
	const [response, setResponse] = useState(null);

	const handleChange = (e) => {
		const { name, value } = e.target;

		setForm({
			...form,
			[name]: value,
		});
	};

	const handleBlur = (e) => {
		handleChange(e);
		setErrors(validateForm(form));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setErrors(validateForm(form));

		if (Object.keys(errors).length === 0) {

			const arrAssignment = {
				validadorid: form.validador,
				solicitudid: solicitudid,
				usuarioid: storage.get('id')
			};

			setLoading(true);
			helpHttp().post(`${BASE_API}demand/reassignment`, {
				body: arrAssignment,
				headers: {
					"Content-Type": "application/json; charset=utf-8",
					"Accept": "application/json",
					'Access-Control-Allow-Origin': '*',
					'x-access-token': storage.get('token')
				},
				}).then((res) => {
					if(res.response == "on") {
						handleHidden();
					} else {

					}

					setLoading(false);
					setResponse(true);
					setForm(initialForm);
					//setTimeout(() => handleExit, 50000);
				});
		} else {
			return;	
		}
	};

	return {
		form,
		errors,
		loading,
		response,
		handleChange,
		handleBlur,
		handleSubmit,
	};
};